<template>
  <footer>
    <b-container class="custom-container pl-0 pr-0">
      <b-row class="gray--2">
        <b-col cols="6" md="2" class="p-0 mb-5 font-weight-bold">
          <b-list-group>
            <!-- <b-list-group-item>Security</b-list-group-item> -->
            <b-list-group-item :href="privacy" target="_blank"
              >Privacy Policy</b-list-group-item
            >
            <b-list-group-item :href="terms" target="_blank"
              >Terms and Conditions</b-list-group-item
            >
          </b-list-group>
        </b-col>

        <b-col cols="6" md="4" class="p-0 mb-5 font-weight-bold">
          <b-list-group-item :to="{ name: 'providers.templates-page' }"
            >Providers</b-list-group-item
          >
          <!-- <b-list-group-item href="#">Help</b-list-group-item> -->
          <b-list-group-item :to="{ name: 'premium.subscription' }"
            >Plans & Pricing</b-list-group-item
          >
        </b-col>

        <b-col md="6" class="p-0">
          <b-list-group-item href="/home">
            <b-img
              v-bind="avatarProps"
              rounded
              alt="Logo"
              src="/img/logo.svg"
            ></b-img>
          </b-list-group-item>
          <b-list-group-item class="gray--3">
            Tradie Pass lets tradies upload and manage certificates, cards and
            licences manage files in one place. It is a modern vault designed to
            reduce admin work and paper wastage - so you can focus on the things
            that matter.
          </b-list-group-item>
        </b-col>
      </b-row>
      <div class="mt-5 text-center gray--3">
        © Created by Appetiser 2020
      </div>
    </b-container>
  </footer>
</template>

<script>
import env from '@/env'
export default {
  data() {
    return {
      avatarProps: {
        height: 36
      }
    }
  },
  computed: {
    terms() {
      return env.cmsUrl + '/support/terms'
    },
    privacy() {
      return env.cmsUrl + '/support/privacy'
    }
  }
}
</script>

<style lang="scss" scoped>
footer {
  background: white 0% 0% no-repeat padding-box;
}
.footer-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.container {
  padding-top: 100px;
  padding-bottom: 50px;
}
.list-group-item {
  background: none;
  padding: 0.25rem 1.25rem;
  border-color: white;
}
.text-center {
  margin-top: 10%;
}
.row {
  margin-right: 0;
  margin-left: 0;
}
</style>
